import React from "react";
import { t } from "i18next";

import InformationBox from "./InformationBox";
import InformationList from "./InformationList";

import { CONTACT, SPECIALIZED_CARE_OPTIONS } from "../../constant/constant";

function InformationSection() {
  return (
    <div id="informationSection" className="provider-search-container">
      <div className="information-sections row">
        <div className="col-md-6 info-box">
          <div className="bottom-menu">
            <InformationBox
              title={t("please-note")}
              icon="icon-exclamation"
              content={
                <>
                  <p>{t("please-note-content-first-paragraph")}</p>
                  <p>{t("please-note-content-second-paragraph")}</p>
                </>
              }
            />
            <InformationBox
              title={t("contact-numbers")}
              icon="icon-phone"
              content={
                <p>
                  {t("within-bermuda")}:{" "}
                  <a
                    className="bluecolor"
                    href={`tel:${CONTACT.WITHIN_BERMUDA_NUMBER}`}
                  >
                    {CONTACT.WITHIN_BERMUDA_NUMBER}
                  </a>{" "}
                  | {t("toll-free")}:{" "}
                  <a
                    className="bluecolor"
                    href={`tel:${CONTACT.TOLL_FREE_NUMBER}`}
                  >
                    {CONTACT.TOLL_FREE_NUMBER}
                  </a>
                  <br /> {t("call-collect")}:{" "}
                  <a
                    className="bluecolor"
                    href={`tel:${CONTACT.CALL_COLLECT_NUMBER}`}
                  >
                    {CONTACT.CALL_COLLECT_NUMBER}
                  </a>{" "}
                  | {t("email")}:{" "}
                  <a href={`mailto:${CONTACT.EMAIL}`} className="bluecolor">
                    {CONTACT.EMAIL}
                  </a>
                </p>
              }
            />
          </div>
        </div>

        <div className="col-md-6 info-box specialized-part">
          <InformationBox
            title={t("specialized-care")}
            icon="icon-user"
            content={
              <div className="bottom-menu">
                <p>
                  {t("please-contact-the-health-service-team")}{" "}
                  <a
                    className="bluecolor"
                    href={`tel:${CONTACT.CALL_COLLECT_NUMBER}`}
                  >
                    {CONTACT.CALL_COLLECT_NUMBER}
                  </a>{" "}
                  {t("for-additional-details-facility-options")}
                </p>
                <InformationList items={SPECIALIZED_CARE_OPTIONS} />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
}

export default InformationSection;
